export enum RegionCode {
  APAC = 'APAC',
  EMEA = 'EMEA',
  LATAM = 'LATAM',
  NA = 'NA',
}

export enum NARegionCountryCodes {
  CANADA = 'CA',
  UNITED_STATES_OF_AMERICA = 'US',
}

export enum EMEARegionountryCodes {
  ANDORRA = 'AD',
  UNITED_ARAB_EMIRATES = 'AE',
  AFGHANISTAN = 'AF',
  ALBANIA = 'AL',
  ARMENIA = 'AM',
  ANGOLA = 'AO',
  ANTARCTICA = 'AQ',
  AUSTRIA = 'AT',
  ÅLAND_ISLANDS = 'AX',
  AZERBAIJAN = 'AZ',
  BOSNIA_AND_HERZEGOVINA = 'BA',
  BELGIUM = 'BE',
  BURKINA_FASO = 'BF',
  BULGARIA = 'BG',
  BAHRAIN = 'BH',
  BURUNDI = 'BI',
  BENIN = 'BJ',
  BOUVET_ISLAND = 'BV',
  BOTSWANA = 'BW',
  BELARUS = 'BY',
  CONGO = 'CD',
  CENTRAL_AFRICAN_REPUBLIc = 'CF',
  SWITZERLAND = 'CH',
  COTE_D_IVOIRE = 'CI',
  COOK_ISLANDS = 'CK',
  CAMEROON = 'CM',
  CABO_VERDE = 'CV',
  CURACAO = 'CW',
  CYPRUS = 'CY',
  CZECHIA = 'CZ',
  GERMANY = 'DE',
  DIJIBOUTI = 'DJ',
  DENMARK = 'DK',
  ALGERIA = 'DZ',
  ESTONIA = 'EE',
  EGYPT = 'EG',
  WESTERN_SAHARA = 'EH',
  ERITREA = 'ER',
  SPAIN = 'ES',
  EITHIOPIA = 'ET',
  FINLAND = 'FI',
  FAROE_ISLANDS = 'FO',
  FRANCE = 'FR',
  GABON = 'GA',
  UNITED_KINGDOM = 'GB',
  GEORGIA = 'GE',
  FRENCH_GUIANA = 'GF',
  GUERNSEY = 'GG',
  GHANA = 'GH',
  GIBRALTA = 'GI',
  GREENLAND = 'GF',
  GAMBIA = 'GM',
  GUINEA = 'GN',
  GUADELOUPE = 'GP',
  EQUATORIAL_GUINEA = 'GQ',
  GREECE = 'GR',
  GUINEA_BISSAU = 'GW',
  HEARD_AND_MCDONALD_ISLANDS = 'HM',
  CROATIA = 'HR',
  HUNGARY = 'HU',
  IRELAND = 'IE',
  ISRAEL = 'IL',
  ISLE_OF_MAN = 'IM',
  IRAQ = 'IQ',
  IRAN = 'IR',
  ICELAND = 'IS',
  ITALY = 'IT',
  JERSEY = 'JE',
  JORDAN = 'JO',
  KENYA = 'KE',
  KYRGYZSTAN = 'KG',
  COMOROS = 'KM',
  KUWAIT = 'KW',
  KAZAKHSTAN = 'KZ',
  LEBANON = 'LB',
  LIECHTENSTEIN = 'LI',
  LIBERIA = 'LR',
  LESOTHO = 'LS',
  LITHUANIA = 'LT',
  LUXEMBOURG = 'LU',
  LATVIA = 'LV',
  LIBYA = 'LY',
  MOROCCO = 'MA',
  MONACO = 'MC',
  MOLDOVA = 'MD',
  MONTENEGRO = 'ME',
  SAINT_MARTIN = 'MF',
  MADAGASCAR = 'MG',
  MACEDONIA = 'MK',
  MALI = 'MI',
  MARTINIQUE = 'MQ',
  MAURITANIA = 'MR',
  MALTA = 'MT',
  MAURITIUS = 'MU',
  MALAWI = 'MW',
  MOZAMBIQUE = 'MZ',
  NAMIBIA = 'NA',
  NEW_CALEDONIA = 'NC',
  NIGER = 'NE',
  NIGERIA = 'NG',
  NETHERLANDS = 'NL',
  NORWAY = 'NO',
  OMAN = 'OM',
  FRENCH_POLYNESIA = 'PF',
  POLAND = 'PL',
  ST_PIERRE_AND_MIQUELON = 'PM',
  PALESTINE = 'PS',
  PORTUGAL = 'PT',
  QATAR = 'QA',
  REUNION = 'RE',
  ROMANIA = 'RO',
  SERBIA = 'RS',
  RUSSIAN_FEDERATION = 'RU',
  RWANDA = 'RW',
  SAUDI_ARABIA = 'SA',
  SEYCHELLES = 'SC',
  SUDAN = 'SD',
  SWEDEN = 'SE',
  ST_HELENA_ASCENSION_TRISTAN_DA_CUNHA = 'SH',
  SLOVENIA = 'SI',
  SLOVAKIA = 'SK',
  SIERRA_LEONE = 'SL',
  SAN_MARINO = 'SM',
  SENEGAL = 'SN',
  SOMALIA = 'SO',
  SOUTH_SUDAN = 'SS',
  SAO_TOME_AND_PRINCIPE = 'ST',
  SINT_MAARTEN = 'SX',
  SYRIA = 'SY',
  SWAZILAND = 'SZ',
  CHAD = 'TD',
  FRENCH_SOUTHERN_TERRITORIES = 'TF',
  TOGO = 'TG',
  TAJIKISTAN = 'TJ',
  TURKMENISTAN = 'TM',
  TUNISIA = 'TN',
  TURKEY = 'TR',
  TANZANIA = 'TZ',
  UKRAINE = 'UA',
  UGANDA = 'UG',
  UZBEKISTAN = 'UZ',
  HOLY_SEE = 'VA',
  WALLS_AND_FUTUNA = 'WF',
  YEMEN = 'YE',
  MAYOTTE = 'YT',
  SOUTH_AFRICA = 'ZA',
  ZAMBIA = 'ZM',
  ZIMBABWE = 'ZW',
}

export enum LATAMRegionCountryCodes {
  ANTIGUA_BARBUDA = 'AG',
  ANGUILLA = 'AI',
  ARGENTINA = 'AR',
  ARUBA = 'AW',
  BARBADOS = 'BB',
  BERMUDA = 'BM',
  BAHAMAS = 'BS',
  BELIZE = 'BZ',
  BOLIVIA = 'BO',
  BRAZIL = 'BR',
  CHILE = 'CL',
  COLOMBIA = 'CO',
  COSTA_RICA = 'CR',
  CUBA = 'CU',
  DOMINICA = 'DM',
  DOMINICAN_REPUBLIC = 'DO',
  ECUADOR = 'EC',
  FALKLAND_ISLANDS = 'FX',
  GRENADA = 'GD',
  SOUTH_GEORGIA_AND_SOUTH_SANDWICH = 'GS',
  GUATEMALA = 'GT',
  GUYANA = 'GY',
  HONDURAS = 'HN',
  HAITI = 'HT',
  JAMAICA = 'JM',
  ST_KITTS_AND_NEVIS = 'KN',
  CAYMAN_ISLANDS = 'KY',
  ST_LUCIA = 'LC',
  MONTSERRAT = 'MS',
  MEXICO = 'MX',
  NICARAGUA = 'NI',
  PANAMA = 'PA',
  PERU = 'PE',
  PUERTO_RICO = 'PR',
  PARAGUAY = 'PY',
  SURINAME = 'SR',
  EL_SALVADOR = 'SV',
  TURKS_AND_CAICOS_ISLANDS = 'TC',
  TRINIDAD_AND_TOBAGO = 'TT',
  URUGUAY = 'UY',
  ST_VINCENT_AND_GRENADINES = 'VC',
  VENEZUELA = 'VE',
  VIRGIN_ISLANDS_BRITISH = 'VG',
  VIRGIN_ISLANDS_US = 'VI',
}

export enum APACRegionCountryCodes {
  AMERICAN_SAMOA = 'AS',
  AUSTRALIA = 'AU',
  BANGLADESH = 'BD',
  BRUNEI = 'BN',
  BHUTAN = 'BT',
  COCOS_KEELING_ISLANDS = 'CC',
  CHINA = 'CN',
  CHRISTMAS_ISLAND = 'CX',
  FIJI = 'FJ',
  MICRONESIA = 'FM',
  GUAM = 'GU',
  HONG_KONG = 'HK',
  INDONESIA = 'ID',
  INDIA = 'IN',
  BRITISH_INDIAN_OCEAN_TERRITORY = 'IO',
  JAPAN = 'JP',
  CAMBODIA = 'KH',
  KIRIBATI = 'KI',
  NORTH_KOREA = 'KP',
  SOUTH_KOREA = 'KR',
  LAOS = 'LA',
  SRI_LANKA = 'LK',
  MARSHALL_ISLANDS = 'MH',
  MYANMAR = 'MM',
  MONGOLIA = 'MN',
  MACAO = 'MO',
  NORTHERN_MARIANA_ISLANDS = 'MP',
  MALDIVES = 'MV',
  MALAYSIA = 'MY',
  NORFOLK_ISLAND = 'NF',
  NEPAL = 'NP',
  NAURU = 'NR',
  NIUE = 'NU',
  NEW_ZEALAND = 'NZ',
  PAPUA_NEW_GUINEA = 'PG',
  PHILLIPINES = 'PH',
  PAKISTAN = 'PK',
  PITCAIRN = 'PN',
  PALAU = 'PW',
  SOLOMON_ISLANDS = 'SB',
  SINGAPORE = 'SG',
  THAILAND = 'TH',
  TOKELAU = 'TK',
  TIMOR_LESTE = 'TL',
  TONGA = 'TO',
  TUVALU = 'TV',
  TAIWAN = 'TW',
  UNITED_STATES_MINOR_OUTLYING_ISLANDS = 'UM',
  VIETNAM = 'VN',
  VANUATU = 'VU',
  SAMOA = 'WS',
}
